import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { 
  ClipboardDocumentListIcon,
  PlusIcon 
} from '@heroicons/react/24/outline';
import FeedForm from './dataentry/FeedForm';
import MedicineForm from './dataentry/MedicineForm';
import WaterQualityForm from './dataentry/WaterQualityForm';
import FishSeedForm from './dataentry/FishSeedForm';
import DeadFishForm from './dataentry/DeadFishForm';
import FishSamplingForm from './dataentry/FishSamplingForm';
import ExpenseForm from './dataentry/ExpenseForm';
import IncomeForm from './dataentry/IncomeForm';
import { useBusinessTypeContext } from '../contexts/BusinessTypeContext';

const DataEntryMenu: React.FC = () => {
  const { businessType } = useBusinessTypeContext();
  
  const fishModules = [
    { id: 'feed', name: 'Feed Log', icon: '🌾', color: 'bg-green-100 text-green-800', implemented: true },
    { id: 'medicine', name: 'Medicine Log', icon: '💊', color: 'bg-red-100 text-red-800', implemented: true },
    { id: 'water-quality', name: 'Water Quality', icon: '💧', color: 'bg-blue-100 text-blue-800', implemented: true },
    { id: 'fish-seed', name: 'Fish Seed Stocking', icon: '🐠', color: 'bg-cyan-100 text-cyan-800', implemented: true },
    { id: 'sampling', name: 'Fish Sampling', icon: '📊', color: 'bg-purple-100 text-purple-800', implemented: true },
    { id: 'mortality', name: 'Dead Fish Log', icon: '💀', color: 'bg-gray-100 text-gray-800', implemented: true },
    { id: 'expense', name: 'Expense Log', icon: '💰', color: 'bg-orange-100 text-orange-800', implemented: true },
    { id: 'income', name: 'Income Log', icon: '💵', color: 'bg-emerald-100 text-emerald-800', implemented: true },
  ];

  const goatModules = [
    { id: 'expense', name: 'Expense Log', icon: '💰', color: 'bg-orange-100 text-orange-800', implemented: true },
    { id: 'income', name: 'Income Log', icon: '💵', color: 'bg-emerald-100 text-emerald-800', implemented: true },
  ];

  const modules = businessType === 'goat' ? goatModules : fishModules;

  return (
    <div className="container-mobile py-6 space-y-6">
      <div className="text-center">
        <ClipboardDocumentListIcon className="h-16 w-16 text-blue-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Data Entry</h1>
        <p className="text-lg text-gray-600">
          Select a module to enter farm data
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {modules.map((module) => (
          <Link
            key={module.id}
            to={`/data-entry/${module.id}`}
            className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-center space-x-4">
              <div className="text-3xl">{module.icon}</div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900">{module.name}</h3>
                <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium mt-2 ${module.color}`}>
                  Ready
                </span>
              </div>
              <PlusIcon className="h-5 w-5 text-gray-400" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};


const DataEntry: React.FC = () => {
  return (
    <Routes>
      <Route index element={<DataEntryMenu />} />
      <Route path="feed" element={<FeedForm />} />
      <Route path="medicine" element={<MedicineForm />} />
      <Route path="water-quality" element={<WaterQualityForm />} />
      <Route path="fish-seed" element={<FishSeedForm />} />
      <Route path="sampling" element={<FishSamplingForm />} />
      <Route path="mortality" element={<DeadFishForm />} />
      <Route path="expense" element={<ExpenseForm />} />
      <Route path="income" element={<IncomeForm />} />
    </Routes>
  );
};

export default DataEntry;